import styled from "styled-components";

export const Container = styled.div`
  padding: 0;
  > :not(:last-child) {
    margin-bottom: 30px;
  }
`;
